<template>
  <div>
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="form">
      <div class="value-selectors">
        <p style="color: #aaa;">{{ $t('dash.checklist.form-intro') }}</p>

        <p>{{ $t('dash.checklist.form-weight') }} <template v-if="lastBioDataEntry">({{ $t('dash.checklist.previous') }}: {{ lastBioDataEntry.weight }})</template></p>
        <ValueSelector :negative="false" type="weight" @change="setWeight" @nan="nan" @negative="nan" ref="weight" />

        <p>{{ $t('dash.checklist.form-length') }} <template v-if="lastBioDataEntry">({{ $t('dash.checklist.previous') }}: {{ lastBioDataEntry.length }})</template> </p>
        <ValueSelector :negative="false" type="length" @change="setLength" @nan="nan" @negative="nan" />

        <br />
        <QandA
          :q="$t('checklist.q.breathing')"
          :a="[
            { answer: $t('checklist.a.lowflownose'), tag: { id: '3d2dc81e-9ff4-4da5-8db1-02dd7f59b41a', label: 'neusbril' } },
            { answer: $t('checklist.a.highflownose'), tag: { id: '3d2dc81e-9ff4-4da5-8db1-02dd7f59b41a', label: 'neusbril' } },
            { answer: $t('checklist.a.breathingArtificial'), tag: { id: '85fc35b7-cbf0-4d7d-a7c2-1f72e167239a', label: 'kunstmatige beademing' } },
            { answer: 'BiPAP/SiPAP', tag: { id: '08c6e38e-b536-4e7e-8b4b-d08f58c78aa9', label: 'BiPAP' } },
            { answer: 'nCPAP', tag: { id: '723474a0-26d6-4e2f-a1bc-2d7a5aa21bae', label: 'nCPAP' } },
            { answer: $t('checklist.a.breathingOwn'), tag: { id: '85fc35b7-cbf0-4d7d-a7c2-1f72e167239a', label: 'kunstmatige beademing' } }
          ]"
          @select="val => setQuestion(1, $t('checklist.q.breathingPrefix'), val)"
        />

        <QandA
          :q="$t('checklist.q.bloodpressure')"
          :a="[
            { answer: $t('checklist.a.katheter2'), tag: { id: 'bcdc5c28-7fdb-4dd4-9e88-fd2226ea891a', label: 'katheter' } },
            { answer: $t('checklist.a.katheder'), tag: { id: 'bcdc5c28-7fdb-4dd4-9e88-fd2226ea891a', label: 'katheter' } },
            { answer: $t('checklist.a.manchette'), tag: { id: '63ccb5c7-97d2-4d95-93fa-e94e9a9aa1ec', label: 'manchette' } }
          ]"
          @select="val => setQuestion(2, $t('checklist.q.bloodpressureprefix'), val)"
        />

        <QandA
          :q="$t('checklist.q.temperature')"
          :a="[
            { answer: $t('checklist.a.openTable'), tag: { id: 'a135af43-8d49-47fc-9b2c-84b2599052d2', label: 'verwarmingstafel' } },
            { answer: $t('checklist.a.closedCouveuse'), tag: { id: '41fa63a1-c4df-4d41-ba22-fae705e3f0a9', label: 'couveuse' } },
            { answer: $t('checklist.a.heatedbed'), tag: { id: '929dd7eb-19a2-453d-a193-a89ca9fbc947', label: 'verwarmd bedje' } },
            { answer: $t('checklist.a.bed'), tag: { id: 'ef865e83-994e-4d10-bd74-e94d99661ae0', label: 'bedje' } }
          ]"
          @select="val => setQuestion(3, $t('checklist.q.temperaturePrefix'), val)"
        />

        <QandA
          :q="$t('checklist.q.food')"
          :a="[
            { answer: $t('checklist.a.bottle'), tag: { id: '63d83276-c67b-4268-af16-00e72c2c7e9a', label: 'flesvoeding' } },
            { answer: $t('checklist.a.borstvoeding'), tag: { id: 'cfb6dd81-c75d-4f8d-8ebf-f82cc6380daf', label: 'voeding' } },
            { answer: $t('checklist.a.probefood'), tag: { id: 'c8765c5c-d714-4a65-9a41-db72414222a4', label: 'sondevoeding' } },
            { answer: $t('checklist.a.cupfeeding'), tag: { id: 'cfb6dd81-c75d-4f8d-8ebf-f82cc6380daf', label: 'voeding' } },
            { answer: $t('checklist.a.tpn'), tag: { id: '13b14e5e-87d9-49d2-9df2-aa4c85acc4f9', label: 'TPN' } },
            { answer: $t('checklist.a.bottleBreast'), tag: { id: '63d83276-c67b-4268-af16-00e72c2c7e9a', label: 'flesvoeding' } },
            { answer: $t('checklist.a.tepelen'), tag: { id: 'cfb6dd81-c75d-4f8d-8ebf-f82cc6380daf', label: 'voeding' } }
          ]"
          @select="val => setQuestion(4, $t('checklist.q.foodPrefix'), val)"
        />

        <QandA
          :q="$t('checklist.q.comfort')"
          :a="[
            { answer: $t('checklist.a.positioning'), tag: { id: 'd1be3982-ac47-4e4a-8bc2-7959a40c659f', label: 'houding' } },
            { answer: $t('checklist.a.reduceLight'), tag: { id: 'e7129020-2a07-48ad-ae76-c68bc306fc8e', label: 'licht' } },
            { answer: $t('checklist.a.reduceNoise'), tag: { id: 'a5dd1a63-d7eb-4e6b-92b9-e3bd2202bf66', label: 'geluid' } },
            { answer: $t('checklist.a.hold'), tag: { id: 'd1be3982-ac47-4e4a-8bc2-7959a40c659f', label: 'houding' } },
            { answer: $t('checklist.a.sleep'), tag: { id: 'bcfa84fe-27de-4509-a357-9f952290912b', label: 'slaapritme' } },
            { answer: $t('checklist.a.parents'), tag: { id: '401ec571-45ea-4109-929e-c0b118202c23', label: 'ouders' } },
            { answer: $t('checklist.a.skincontact'), tag: { id: 'a01350d5-9a79-4d16-8645-45ef2b951b5f', label: 'kangoeroeën' } },
            { answer: $t('checklist.a.painreduction'), tag: { id: '27cf4e9a-934e-4071-be57-4841d9c88455', label: 'pijn' } }
          ]"
          @select="val => setQuestion(5, $t('checklist.q.comfortPrefix'), val)"
        />

        <QandA
          :q="$t('checklist.q.examinations')"
          :a="[
            { answer: $t('checklist.a.eye'), tag: { id: '4aa7eb76-d3d3-4b24-a210-51b01ae1f61f', label: 'oogonderzoek' } },
            { answer: $t('checklist.a.scan'), tag: { id: '4c2576f7-5503-4360-acbc-ba890481c6f8', label: 'MRI' } },
            { answer: $t('checklist.a.hielprik'), tag: { id: 'd7039c53-7686-49cf-b6e8-ac5217358448', label: 'hielprik' } },
            { answer: $t('checklist.a.hearing'), tag: { id: '0b589307-1292-49ae-ac79-6306770fb131', label: 'BERA' } },
            { answer: $t('checklist.a.rx'), tag: { id: '58462a8d-2a6b-426b-9601-7b71161ff46f', label: 'RX' } },
            { answer: $t('checklist.a.ecg'), tag: { id: '54b1b26c-c033-427b-b81e-c1ae567cb04e', label: 'ECG' } },
            { answer: $t('checklist.a.echo'), tag: { id: 'f0449be7-dafe-4783-9a13-b6ddbcd9d04e', label: 'echografie' } },
            { answer: $t('checklist.a.eeg'), tag: { id: 'b7977c43-65ed-4a71-a8b7-93d4972a748b', label: 'EEG' } },
            { answer: $t('checklist.a.sep'), tag: { id: 'fa047537-ff68-4ff7-b1f5-33168e18816d', label: 'SEP' } },
            { answer: $t('checklist.a.cfm'), tag: { id: 'bf905e9f-8df2-4bd7-bd93-8ce6be2c7a5a', label: 'CFM' } }
          ]"
          @select="val => setQuestion(6, $t('checklist.q.examinationPrefix'), val)"
        />
      </div>

      <TextAreaField
        :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }"
        :inputStyles="{ border: 0, margin: 0 }"
        class="input"
        v-model="content"
        :labelTitle="$t('dash.checklist.form-post')"
        :placeholder="$t('dash.checklist.form-post-placeholder')"
        rows="2"
        style="margin-bottom: 16px"
      />
    </div>

    <ListItem icon="eye-blue.svg" @click.native="$modal.show('access-menu-modal')">
      {{ $t('dash.checklist.form-visibility') }}:
      <span>{{
          access === 'pub'
            ? $t('dash.checklist.visibility-unrestricted')
            : $t('dash.checklist.visibility-restricted')
        }}</span>
    </ListItem>

    <LoadingButton v-if="loading" style="margin: 16px 0"></LoadingButton>
    <div v-else>
      <Button
        v-if="!this.postId"
        @click.native="writePost('add')"
        :title="$t('dash.checklist.action-post')"
        style="margin: 16px 0"
      />
      <Button
        v-else
        @click.native="writePost('edit')"
        :title="$t('dash.checklist.action-save')"
        style="margin: 16px 0"
      />
    </div>

    <modal class="menu" :name="'access-menu-modal'" width="100%" height="auto">
      <ListItem
        :highlighted="access === 'pub' ? true : false"
        border="1px solid #31b9be"
        @click.native="
          access = 'pub';
          $modal.hide('access-menu-modal');
        "
      >{{ $t('dash.checklist.visibility-unrestricted') }}</ListItem
      >
      <ListItem
        :highlighted="access === 'priv' ? true : false"
        border="1px solid #31b9be"
        last="true"
        @click.native="
          access = 'priv';
          $modal.hide('access-menu-modal');
        "
      >{{ $t('dash.checklist.visibility-restricted') }}</ListItem
      >
    </modal>
  </div>
</template>

<script>
import {neoparentPatients, neoparentPosts} from "@/api";
import InputField from "@/page_elements/InputField";
import TextAreaField from "@/page_elements/TextAreaField";
import LoadingButton from "@/page_elements/LoadingButton";
import ListItem from "@/page_elements/ListItem";
import Button from "@/page_elements/Button";
import Post from "@/page_elements/Post";
import Header from "@/layouts/shared/Header";
import Upload from "@/page_elements/Upload";
import ValueSelector from "@/page_elements/ValueSelector";
import QandA from "@/page_elements/QandA";
import DictionarySelector from "@/page_elements/Dictionary/DictionarySelector";
import AddedDictionaryEntries from "@/page_elements/Dictionary/AddedDictionaryEntries";

export default {
  name: "neoparent-create-checklist",
  components: {
    InputField,
    TextAreaField,
    ListItem,
    Button,
    LoadingButton,
    Post,
    Upload,
    Header,
    DictionarySelector,
    AddedDictionaryEntries,
    ValueSelector,
    QandA
  },
  data() {
    return {
      content: this.$store.state.post.content || this.$t('dash.checklist.form-post-value'),
      access: this.$store.state.post.access,
      postId: this.$store.state.post.postId,
      loading: false,
      weight: null,
      length: null,
      checklist: {
        questions: []
      },
      error: '',
      lastBioDataEntry: null
    };
  },
  mounted() {
    // Autofocus
    this.$refs.weight.$el.children[1].children[0].focus();
    this.getLastBioDataEntry()
  },
  methods: {
    getLastBioDataEntry() {
      const that = this
      neoparentPatients.getLatestBioDataEntryForPatient(this.$store.getters.patient.id)
        .then((res) => {
        that.lastBioDataEntry = res.data.biodataEntry
      })
    },
    writePost: async function(action) {
      if (action !== 'add' && action !== 'edit') return;
       this.loading = true;

        // Add biodataEntry
        await neoparentPatients
          .addBioDataEntry(this.$store.getters.patient.id, {
            weight: this.weight,
            length: this.length,
          })

        // Create post
        const postData = {
          title: this.$t('dash.checklist.form-title'),
          content: this.content,
          access: this.access
        }

        let postId = null;
        await neoparentPosts
          .addPost(this.$store.getters.patient.id, postData)
          .then(x => {
            postId = x.data.post.id;
          })

        // Add checklist
        // Prep data object for backend
        const data = [];

        if (this.weight) {
          data.push({
            question: this.$t('dash.checklist.form-weight'),
            answer: [{answer: this.weight + 'g'}]
          });
        }

        if (this.length) {
          data.push({
            question: this.$t('dash.checklist.form-length'),
            answer: [{answer: this.length + 'cm'}]
          });
        }

        this.checklist.questions.forEach(q => {
          // Filter out empty
          if (q.value.length > 0) {
            data.push({
              question: q.key,
              answer: q.value
            });
          }
        });

        await neoparentPosts.addChecklist(postId, data)
        .then(() => {
          this.loading = false;

          if (this.$store.getters.nurse) {
            window.location.href = `/dashboard/nurse/${this.$store.getters.nurse.id}/patient/${this.$store.getters.user.patient.id}`;
          } else {
            window.location.href = `/dashboard/nurse/${this.$store.getters.user.id}/patient/${this.$store.getters.user.patient.id}`;
          }
        })
    },
    setWeight(val) {
      this.error = null;
      this.weight = val;
    },
    setLength(val) {
      this.error = null;
      this.length = val;
    },
    setQuestion(id, key, value) {
      this.checklist.questions[id] = { key, value };
    },
    nan() {
      this.error = this.$t('error.biodata.not-numeric');
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 1rem auto 0.5rem;
  text-align: center;
  max-width: 500px;
}

.value-selectors {
  margin: 0 5%;
}

.value-selectors div,
.input {
  max-width: 500px;
  margin: 0 auto;
}
.error {
  margin: 0 5%;
}
</style>
